// utils/stringHelper.js
import {formatDecimal} from "@/utils/numberHelper.js";


export function monthNumberToShortName(monthNumber) {
    const months = [
        'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
        'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
    ];
    return months[monthNumber - 1] || '';
}

export function monthNumberToFullName(monthNumber) {
    const months = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];
    return months[monthNumber - 1] || '';
}

export function nl2br(value) {
    if (!value) return '';
    return value.replace(/\n/g, '<br>');
}

export function capitalizeFirstLetter(string) {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function truncateString(string, maxLength) {
    if (!string) return '';
    if (string.length <= maxLength) return string;
    return string.slice(0, maxLength) + '...';
}

export function booleanToHuman (value) {
    if (value === undefined || value === null) return '';

    if(value) {
        return  'Sim'
    }

    return 'Não'
}


export function saudacao() {
    var now = new Date();

    if(now.getHours() < 12) {
        return 'Bom dia'
    }

    if(now.getHours() < 18) {
        return 'Boa tarde'
    }

    if(now.getHours()) {
        return 'Boa noite'
    }

}

export function FormatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    const value = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals))

    return  formatDecimal(value) + ' ' + sizes[i];
}

export function Slugfy(value) {
    if (value === undefined || value === null) return '';


    return value
        .toString() // Converte para string
        .normalize("NFD") // Normaliza para decompor acentos
        .replace(/[\u0300-\u036f]/g, "") // Remove acentos
        .replace(/[^a-zA-Z0-9\s-]/g, '') // Remove caracteres especiais
        .trim() // Remove espaços em branco nas extremidades
        .replace(/\s+/g, '-') // Substitui espaços por hífens
        .toLowerCase(); // Converte para minúsculas
}

export function formatCNPJ(cnpj) {
    if(!cnpj) {
        return
    }
    cnpj = cnpj.replace(/\D/g, "");

    if (cnpj.length === 14) {
        return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    }

    return cnpj;
}


export function formatCNPJFamilia(cnpj) {
    if(!cnpj) {
        return
    }
    cnpj = cnpj.replace(/\D/g, "");
    if (cnpj.length === 8) {
        return cnpj.replace(/^(\d{2})(\d{3})(\d{3})$/, "$1.$2.$3");
    }

    return cnpj;
}


export function formatCnae(value) {
    if(!value) {
        return
    }
    value = value.replace(/\D/g, "");

    if (value.length === 7) {
        return value.replace(/^(\d{4})(\d{1})(\d{2})$/, "$1-$2/$3");
    }

    return value;
}


export function formatCep(value) {
    if(!value) {
        return
    }
    value = value.replace(/\D/g, "");

    if (value.length === 8) {
        return value.replace(/^(\d{5})(\d{3})$/, "$1-$2");
    }

    return value;
}


export function formatFone(value) {
    if(!value) {
        return
    }
    value = value.replace(/\D/g, "");

    // --- Telefone com 11 dígitos (celular: (99) 99999-9999) ---
    if (value.length === 11) {
        return value.replace(
            /^(\d{2})(\d{5})(\d{4})$/,
            "($1) $2-$3"
        );
    }

    // --- Telefone com 10 dígitos (fixo: (99) 9999-9999) ---
    if (value.length === 10) {
        return value.replace(
            /^(\d{2})(\d{4})(\d{4})$/,
            "($1) $2-$3"
        );
    }

    return value;
}





export function compareJson(obj1, obj2) {
    obj1 = normalizeDiffInput(obj1);
    obj2 = normalizeDiffInput(obj2);

    const diff = {};
    const keys = Object.keys(obj1);

    // Verificar chaves no primeiro objeto
    for (const keyIndex in keys) {
        let key = keys[keyIndex]

        if (!Object.prototype.hasOwnProperty.call(obj2, key)) {
            // Propriedade foi removida
            diff[key] = { status: "removed", value: obj1[key] };
        } else if (isObject(obj1[key]) && isObject(obj2[key])) {
            // Comparação recursiva para objetos aninhados
            const nestedDiff = diffObjects(obj1[key], obj2[key]);
            if (Object.keys(nestedDiff).length > 0) {
                diff[key] = { status: "nested", value: nestedDiff };
            }
        } else if (obj1[key] !== obj2[key]) {
            // Valor foi modificado
            diff[key] = { status: "modified", original: obj1[key], updated: obj2[key] };
        } else {
            diff[key]= { status: "not_changed", original: obj1[key], updated: obj2[key] };
        }
    }

    const keysObject2 = Object.keys(obj2);
    // Verificar chaves no segundo objeto (adições)
    for (const keyIndex in keysObject2) {
        let key = keysObject2[keyIndex]
        if (!Object.prototype.hasOwnProperty.call(obj1, key)) {
            // Propriedade foi adicionada
            diff[key] = { status: "added", value: obj2[key] };
        }
    }

    return diff;
}

function normalizeDiffInput(input) {
    if (input === undefined || input === null) {
        return {};
    }

    if (Array.isArray(input)) {
        return listToObject(input);
    }

    if (typeof input === "string") {
        if (input.trim() === "") {
            return {};
        }

        return JSON.parse(input);
    }

    if (isObject(input)) {
        return input;
    }

    return {};
}

// A ordem importa: `value`/`Value` antes de `newValue`/`NewValue`, como era nos dois `if`
// encadeados que isto substituiu.
const CAMPOS_DE_VALOR = ["value", "Value", "newValue", "NewValue"];

// `hasOwnProperty` e nao `??` de proposito: aqui um valor explicitamente `null` conta como
// presente, que era o comportamento original.
function primeiroCampoPresente(item, campos) {
    for (const campo of campos) {
        if (Object.prototype.hasOwnProperty.call(item, campo)) {
            return { presente: true, valor: item[campo] };
        }
    }
    return { presente: false, valor: undefined };
}

function listToObject(list) {
    const output = {};

    list.forEach((item) => {
        if (!item) {
            return;
        }

        const key = item.field ?? item.Field ?? item.name ?? item.Name;
        if (!key) {
            return;
        }

        const achado = primeiroCampoPresente(item, CAMPOS_DE_VALOR);
        if (achado.presente) {
            output[key] = achado.valor;
        }
    });

    return output;
}

function diffObjects(obj1, obj2) {
    return compareJson(obj1, obj2);
}

export function isObject(value) {
    return value && typeof value === "object" && !Array.isArray(value);
}

export function formatDiff(diff, showAll) {
    const formatter = (obj, level = 0) => {
        return Object.entries(obj)
            .map(([key, { status, original, updated, value }]) => {
                const indent = "&nbsp;".repeat(level * 4);
                if(showAll) {
                    return `${indent}<span > ${key}: ${JSON.stringify(updated)}</span>`;
                } else if (status === "nested") {
                    return `${indent}<strong>${key}</strong>:<br>${formatter(updated, level + 1)}`;
                } else if (status === "added") {
                    return `${indent}<span class="diff-add">+ ${key}: ${JSON.stringify(value)}</span>`;
                } else if (status === "removed") {
                    return `${indent}<span class="diff-remove">- ${key}: ${JSON.stringify(original)}</span>`;
                } else if (status === "modified") {
                    return `${indent}<span class="diff-change">~ ${key}: ${JSON.stringify(original)} ➡ ${JSON.stringify(updated)}</span>`;
                } else {
                    return ``;
                }
            })
            .filter(Boolean)
            .join("<br>");
    };

    return formatter(diff);
}


// Digito verificador do CPF sobre os `ate` primeiros digitos. Os pesos descem a partir de
// `ate + 1`, que e o que as duas metades duplicadas faziam com (10 - i) e (11 - i).
function digitoVerificadorCPF(cpf, ate) {
    let sum = 0;
    for (let i = 0; i < ate; i++) sum += parseInt(cpf[i]) * (ate + 1 - i);
    const rev = 11 - (sum % 11);
    return rev >= 10 ? 0 : rev;
}

export function isValidCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

    if (digitoVerificadorCPF(cpf, 9) !== parseInt(cpf[9])) return false;
    return digitoVerificadorCPF(cpf, 10) === parseInt(cpf[10]);
}

// Digito verificador do CNPJ sobre os `size` primeiros digitos. As duas metades duplicadas
// so diferiam em `size` (12 e 13); `digits` nao era recalculado na segunda, e continua assim.
function digitoVerificadorCNPJ(cnpj, size) {
  const numbers = cnpj.substring(0, size);
  let sum = 0;
  let pos = size - 7;
  for (let i = size; i >= 1; i--) {
    sum += numbers.charAt(size - i) * pos--;
    if (pos < 2) pos = 9;
  }
  return sum % 11 < 2 ? 0 : 11 - (sum % 11);
}

export function isValidCNPJ(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj.length !== 14) return false;

  // Elimina CNPJs inválidos conhecidos
  if (/^(\d)\1+$/.test(cnpj)) return false;

  // Valida DVs
  const digits = cnpj.substring(12);
  if (digitoVerificadorCNPJ(cnpj, 12) !== parseInt(digits.charAt(0))) return false;
  return digitoVerificadorCNPJ(cnpj, 13) === parseInt(digits.charAt(1));
}


export function darkenColor(hex, levels = 3, step = 10) {
    const hsl = hexToHSL(hex);
    hsl.l = Math.max(0, hsl.l - levels * step);
    return hslToHex(hsl);
}

function hexToHSL(hex) {
    hex = hex.replace('#', '');
    if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
    }

    const r = parseInt(hex.substring(0,2), 16) / 255;
    const g = parseInt(hex.substring(2,4), 16) / 255;
    const b = parseInt(hex.substring(4,6), 16) / 255;

    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max === min){
        h = s = 0;
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r: h = ((g - b) / d + (g < b ? 6 : 0)); break;
            case g: h = ((b - r) / d + 2); break;
            case b: h = ((r - g) / d + 4); break;
        }
        h *= 60;
    }

    return { h, s, l: l * 100 };
}

function hslToHex({ h, s, l }) {
    l /= 100;
    const a = s * Math.min(l, 1 - l);
    const f = n => {
        const k = (n + h / 30) % 12;
        const c = l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1));
        return Math.round(255 * c).toString(16).padStart(2, '0');
    };
    return `#${f(0)}${f(8)}${f(4)}`;
}


export function getFirstName(fullName) {
    if (!fullName) return '';
    return fullName.trim().split(' ')[0];
}

export function formatLogradouro(logradouro, numero, complemento) {
    let endereco = []


    if(logradouro) {
        endereco.push(logradouro)
    }


    if(numero) {
        endereco.push(numero)
    }

    if(complemento) {
        endereco.push(complemento)
    }


    if(endereco.length > 0) {
        return endereco.join(', ')
    }


    return 'N/A'
}

export function formatCEP(value) {
    value = value.trim()

    if(!value) {
        return "" // CEP inválido
    }

    // Remove todos os caracteres não numéricos do valor
    value = value.replace(/\D/g, '');

    // Adiciona o traço na máscara XXXXX-XXX
    // O primeiro grupo de 5 dígitos (\\d{5}) é capturado em $1, e o segundo grupo de 3 dígitos (\\d) é capturado em $2
    value = value.replace(/(\d{5})(\d)/, '$1-$2');
    return value
}

export function formatFilial(row){
  if (row.filial === 'PRANA COMEX - FILIAL RO') {
    return "PRANA - RO"
  } else if (row.filial === 'PRANA COMEX'){
    return "PRANA - SC"
  }

  return row.filial
}

export function formatNumeroRegistroDI(isDuimp, value) {
    if (!value) {
        return '';
    }

    if (isDuimp) {
      return value
    }

    value = value.replace(/\D/g, '');

    const firstSection = value.slice(0, 9);
    const secondSection = value.slice(9, 10);

    return `${firstSection}-${secondSection}`;
}

export function getFileName(disposition) {
  if (!disposition) return null;

  const utf8FilenameRegex = /filename\*=UTF-8''([\w%.-]+)(?: ?|$)/i;
  const utf8Match = disposition.match(utf8FilenameRegex);
  if (utf8Match) {
    return decodeURIComponent(utf8Match[1]);
  }

  const asciiFilenameRegex = /filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;
  const asciiMatch = disposition.match(asciiFilenameRegex);
  if (asciiMatch) {
    return asciiMatch[2];
  }

  return null;
}

export function escapeHtml(value) {
    if (value === null || value === undefined) return '';

    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };

    return String(value).replace(/[&<>"']/g, (char) => map[char]);
}
